import React from 'react'
import Link from '../../components/Link'

const BlogPage = () => {
  return (
    <div className="container">
      <div className="blog" style={{ margin: '0 auto', maxWidth: '70ch' }}>
        <Link href="/blog">Latest &#8594;</Link>
        <h2>Presenting your requests to our Father in Heaven</h2>
        <span className="author">by Jon Shulver, 20 March 2020</span>
        <p>
          Paul says in Philippians 4:6 “Do not be anxious about anything, but in
          every situation, by prayer and petition, with thanksgiving present
          your requests to God.”
        </p>
        <p>
          Let’s be honest, most of us have felt some anxiety over the last week.
          It’s hard not to. But God wants to take our anxiety from us. He wants
          us, as best we can, to hand it over to him; to exchange it for his
          peace (Philippians 4:7). Paul says that a vital means of doing that is
          to pray to God: to present our requests to him. To exchange anxiety
          for peace, as we pray.
        </p>
        <p>
          But how should we pray? What can we ask for? Well, Paul says we can
          simply “present our requests to God”.
        </p>
        <p> Our requests might currently be something like this:</p>
        <p style={{ paddingLeft: '2em' }}>
          “Please God, in your mercy, help the spread of the virus to soon
          stop.”
          <br />
          “Please God, give wisdom to our government and the rulers you have
          placed over us, as they have to make difficult decisions.”
          <br />
          “Please God, for those that are needy and vulnerable: shield them from
          infection and help us love them as we love ourselves.”
          <br />
          "Please God, for those who are working to provide medical care and
          essential services: grant them protection and strength.”
        </p>
        <p>
          Let’s also remember the prayer that Jesus taught his disciples to
          pray; his model prayer of handing our needs, our sin and our anxiety
          over to God.
        </p>
        <p>In Matthew 6, Jesus said:</p>
        <p style={{ paddingLeft: '2em' }}>
          “This, then, is how you should pray:
          <br /> "Our Father in heaven, hallowed be your name,
          <br />
           your kingdom come,
          <br />
          your will be done,
          <br />
              on earth as it is in heaven.
          <br />
           Give us today our daily bread. <br />
          And forgive us our debts,
          <br />
              as we also have forgiven our debtors.  
          <br />
          And lead us not into temptation,
          <br />
             but deliver us from the evil one."
        </p>
        <p>
          Down the centuries, countless millions have used these words as a
          basis for prayer and a help in bringing their requests to God. Can I
          encourage us to do the same? To pray to “Our Father in heaven”. There
          is much comfort in those opening words. He is Our Father. Because of
          the death and resurrection of Jesus, we can know and speak to God as
          Our Father. Not a force or power, not an impersonal God, not a distant
          relative, but Our Father. A loving father who cares for his children,
          but also a father who is in heaven. He’s not limited in power and
          knowledge and love like earthly fathers. But he’s Our Father in
          heaven, whose power and knowledge and love is complete.
        </p>
        <p>Our Father in Heaven. That’s who is waiting to hear our requests.</p>
        <p>Jon</p>
        <p>
          If you want to listen to more of what the Bible says about anxiety and
          worry then you can listen to a talk given at a Cornerstone gathering
          via the following link: &nbsp;
          <a href="http://talks.cornerstonechurchportsmouth.org/sermons/?wpfc_sermon_series=battles-christians-face">
            Battles Christians Face
          </a>
        </p>
      </div>
    </div>
  )
}

export default BlogPage



// WEBPACK FOOTER //
// ./src/pages/blog/20-march.js